/**!
 * Created by Leonardo Cheslacki on 28/10/2025.
 *
 * MIT License
 *
 * Copyright (c) 2025 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/**
 * Compiler -- min-resources=app
 * name: {string} FLA file name;
 * frame: {int} Menu button number, Ex: Number 2 is the occurrence btn_page02,
 * you cannot use number 1 because it is reserved for the empty page "In adobe animate, the frame with the label frame01 is empty because of the bugs."
 * type: {string} Type of link 'video', 'tour', 'external', 'paginate' or 'audio';
 * uri: {string} URI or URL when use a 'type';
 * logo: {string} It's size of the logo 'none', 'small', 'medium' or 'large';
 * dynamic: {boolean} Layer "background_dynamic" synchronized with the button;
 * default: {string} Page default init;
 *
 * xml: For multi or only one gallery, add frame01Gallery in actions.
 *
 * Marker changes from 'frame';
 * Occurrence btn_page** execute the 'frame**' correspondent, Ex: 'btn_page02' for 'frame02';
 */
module.exports.menu = [
    {
        name: 'capa',
        frame: 2,
        uri: null,
        type: null,
        logo: 'none',
        dynamic: true,
        default: true
    },
    {
        name: 'localizacao',
        frame: 3,
        uri: null,
        type: null,
        logo: 'large',
        dynamic: true,
        default: false
    },
    {
        name: 'projetistas',
        frame: 4,
        uri: null,
        type: null,
        logo: 'large',
        dynamic: true,
        default: false
    },
    {
        name: 'diferenciais',
        frame: 5,
        uri: null,
        type: null,
        logo: 'large',
        dynamic: true,
        default: false
    },
    {
        name: 'implantacoes',
        frame: 6,
        uri: null,
        type: 'paginate',
        logo: 'large',
        dynamic: true,
        default: false,
        paginates: [
            {
                name: 'implantacao01',
                frame: 1,
                uri: null,
                type: null,
                xml: 'implantation01.xml',
                content_text: {
                    frame_01: {
                        A: 6
                    }
                },
                // extra: {
                //     pin: {
                //         color_round: '0x8B422C'
                //     },
                //     text: {
                //         color_number: '0xFFFFFF',
                //         color_text: '0x585B58'
                //     }
                // },
                default: true
            },
            {
                name: 'implantacao02',
                frame: 2,
                uri: null,
                type: null,
                xml: 'implantation02.xml',
                content_text: {
                    frame_01: {
                        A: 20
                    }
                },
                default: false
            },
            {
                name: 'implantacao03',
                frame: 3,
                uri: null,
                type: null,
                xml: 'implantation03.xml',
                content_text: {
                    frame_01: {
                        A: 5
                    }
                },
                default: false
            }
        ]
    },
    {
        name: 'orientacao',
        frame: 7,
        uri: null,
        type: null,
        logo: 'large',
        dynamic: true,
        default: false
    },
    {
        name: 'imagens',
        frame: 8,
        uri: null,
        type: null,
        xml: 'gallery.xml',
        logo: 'large',
        dynamic: true,
        default: false
    },
    {
        name: 'plantas',
        frame: 9,
        uri: null,
        type: 'paginate',
        logo: 'large',
        dynamic: true,
        default: false,
        paginates: [
            {
                // menu: true,
                name: 'planta01',
                frame: 1,
                uri: null,
                type: null,
                active: {
                    differential: true,
                    // differential_enabled: false,
                    camera: true,
                    // pin: true
                },
                default: true
            },
            // {
            //     // menu: true,
            //     name: 'imagens',
            //     frame: 2,
            //     uri: null,
            //     type: null,
            //     xml: 'gallery_.xml',
            //     default: false
            // },
            {
                name: 'planta02',
                frame: 2,
                uri: null,
                type: null,
                active: {
                    differential: true,
                    // differential_enabled: false,
                    camera: true,
                    // pin: true
                },
                default: false
            },
            {
                name: 'planta03',
                frame: 3,
                uri: null,
                type: null,
                active: {
                    differential: true,
                    // differential_enabled: false,
                    camera: true,
                    // pin: true
                },
                default: false
            },
            {
                name: 'planta04',
                frame: 4,
                uri: null,
                type: null,
                active: {
                    differential: true,
                    // differential_enabled: false,
                    camera: true,
                    // pin: true
                },
                default: false
            },
            {
                name: 'planta05',
                frame: 5,
                uri: null,
                type: null,
                active: {
                    differential: true,
                    // differential_enabled: false,
                    camera: true,
                    // pin: true
                },
                default: false
            }
        ]
    },
    {
        name: 'ficha',
        frame: 10,
        uri: null,
        type: null,
        logo: 'large',
        dynamic: true,
        default: false
    },
    {
        name: 'vistas',
        frame: 11,
        uri: 'example.mp4',
        type: 'tour',
		uri: 'https://metropolitan.interativo.app.br/app/vistas',
        logo: 'large',
        dynamic: true,
        default: false
    },
    {
        name: 'videos',
        frame: 12,
		uri: null,
        type: null,
        logo: 'large',
        dynamic: true,
        default: false
    }
];

module.exports.fullscreen = {
    /**
     * fullscreen or audio
     */
    type: 'fullscreen',
    size: {
        width: 300,
        height: 'auto'
    },
    logo: 'icons/favicon-white.png',
    confirm: {
        disabled: false,
        text: 'Visualizar em tela cheia',
        // text: 'Ativar áudio',
        class: 'btn-default'
    },
    cancel: {
        disabled: false,
        text: 'Não, obrigado',
        class: 'btn-default'
    },
    /**
     * https://github.com/craftpip/jquery-confirm
     */
    options: {
        content: false,
        theme: 'supervan',
        closeIcon: false,
        animation: 'scale',
        draggable: false
    }
};

module.exports.init = {
    fullscreen: true,
    before: false,
    /**
     * Single, compiler -- min-resources=main
     */
    single: false,
    gallery: false,
    frame: 1,
    marker: true,
    marker_animate: true
};
